import { yup } from '@guiker/yup-util'

export const tenantPreferenceByUserId = yup.object({
  userId: yup.string().required(),
})
